function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { BASE_SPACING, BASE_STYLES } from './constants';
import { Spacing } from '../theming';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
var StyledStack = styled.div.withConfig({
  displayName: "Stack__StyledStack",
  componentId: "sc-1ypldv5-0"
})(["", " margin-bottom:", "px;"], BASE_STYLES, function (props) {
  return props.size;
});

var Stack = function Stack(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["children", "tag"]);

  return /*#__PURE__*/React.createElement(StyledStack, _extends({
    as: tag
  }, props), children);
};

Stack.Sizes = Spacing;
Stack.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(Object.values(Stack.Sizes)),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
Stack.defaultProps = {
  size: BASE_SPACING
};
export default Stack;